import QuestionComponent from './QuestionComponent';

export default QuestionComponent;
